import React, { useEffect, useRef, useState } from 'react';

const JS_URL = 'https://prime-plan-creator-dev.lovable.app/index.js';
const CSS_URL = 'https://prime-plan-creator-dev.lovable.app/index.css';

export default function EstatePlanning() {
    const containerRef = useRef(null);
    const [error, setError] = useState('');

    useEffect(() => {
        let scriptEl;
        let linkEl;

        // load css
        linkEl = document.createElement('link');
        linkEl.rel = 'stylesheet';
        linkEl.href = CSS_URL;
        linkEl.setAttribute('data-estate-planning-css', 'true');
        document.head.appendChild(linkEl);

        // create mount container
        if (containerRef.current) {
            containerRef.current.innerHTML = '';
        }

        // load js
        scriptEl = document.createElement('script');
        scriptEl.src = JS_URL;
        scriptEl.async = true;
        scriptEl.setAttribute('data-estate-planning-js', 'true');

        scriptEl.onload = () => {
            try {
                /**
                 * Case 1:
                 * remote script exposes a global mount function
                 * example: window.EstatePlanningApp.mount(element)
                 */
                if (window.EstatePlanningApp?.mount && containerRef.current) {
                    window.EstatePlanningApp.mount(containerRef.current, {
                        pageName: 'EstatePlanning',
                    });
                    return;
                }

                /**
                 * Case 2:
                 * remote script auto-renders itself into a known selector
                 * then you may need to give it a specific id
                 */
                if (containerRef.current) {
                    containerRef.current.id = 'estate-planning-root';
                }

                /**
                 * If nothing mounted, show a useful message
                 */
                setError('The remote app loaded, but no mount function was found. The Lovable app may need a small export wrapper.');
            } catch (e) {
                setError(e.message || 'Unable to initialize EstatePlanning app');
            }
        };

        scriptEl.onerror = () => {
            setError('Failed to load remote EstatePlanning script');
        };

        document.body.appendChild(scriptEl);

        return () => {
            if (scriptEl?.parentNode) scriptEl.parentNode.removeChild(scriptEl);
            if (linkEl?.parentNode) linkEl.parentNode.removeChild(linkEl);

            if (window.EstatePlanningApp?.unmount && containerRef.current) {
                try {
                    window.EstatePlanningApp.unmount(containerRef.current);
                } catch {}
            }
        };
    }, []);

    return (
        <div style={{ width: '100%', minHeight: '100vh' }}>
            <div ref={containerRef} id="estate-planning-root" style={{ width: '100%', minHeight: '800px' }} />
        </div>
    );
}
